import Renderer from './renderer'

export default function render(tree) {
  const renderer = new Renderer()
  return renderer.render(tree)
}
